const SubAbasTickets = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/daf/maisopcoes/tickets/ficha/${id}/dadosgerais`,
  },
  //   {
  //     label: 'Produtos',
  //     rota: `/daf/produtosdaf/denominacoes/ficha/${id}/produtos`,
  //   },
];

export default SubAbasTickets;
